/**
 * Turning one of the six ported shader programs into a three.js material.
 *
 * Lives on its own so that both the deferred pipeline and the shadow pass can build
 * materials without one importing the other.
 */

import { GLSL3, RawShaderMaterial } from 'three';
import { SHADER_PROGRAMS } from './shaders';

/**
 * Three.js prepends its own `#version` directive when `glslVersion: GLSL3` is set, and the
 * ported sources already carry one. Two directives is a compile error, so strip ours.
 */
export function stripVersion(source: string): string {
  return source.replace(/^\s*#version[^\n]*\n/, '');
}

export function programMaterial(
  name: keyof typeof SHADER_PROGRAMS,
  uniforms: Record<string, { value: unknown }>,
): RawShaderMaterial {
  const program = SHADER_PROGRAMS[name];
  return new RawShaderMaterial({
    vertexShader: stripVersion(program.vertex),
    fragmentShader: stripVersion(program.fragment),
    glslVersion: GLSL3,
    uniforms,
  });
}
